// Generated by `npm run brand` from brand/brand.json — edit that file, not this one.
export const APP_NAME = "ClanFire";
export const APP_TAGLINE = "Real-time chat, voice and communities.";

/** Who runs the app (brand.json "legal"): used by the privacy policy, terms and sign-up. */
export const LEGAL = {
  "operator": "Christopher Todd",
  "contactEmail": "contact@clanfire.cc",
  "country": "United Kingdom",
  "address": "",
  "companyNumber": "",
  "minimumAge": 13,
  "effectiveDate": "2026-10-17"
} as const;
/** True while brand.json still has "[...]" placeholders in "legal". */
export const LEGAL_PLACEHOLDERS = false;
